
import { Step } from "@/lib/types";

export const congratulationsStep: Step = {
  id: "congratulations",
  type: "step",
  title: "Congratulations! 🎉",
  description: `
  Amazing job! You've successfully completed the onboarding process for Cray Cray Reposters.
  
  You now have:
  
  ✅ Created and warmed up your TikTok account
  ✅ Set up your profile correctly
  ✅ Learned how to use the Reposter Dashboard
  
  We're excited to have you on board and can't wait to see your content performing well.
  
  If you have any questions, remember you can always reach out to our team through Upwork or WhatsApp.
  
  Let's make some amazing content together!
  `,
  buttonText: "Complete Onboarding"
};
